<script>
    import { onMount } from "svelte";

    import Button from "@smui/button";
    import Select, { Option } from "@smui/select";
    import Textfield from "@smui/textfield";

    import { post } from "../../http";

    import title from "../../components/title";
    import { getObject, setObject } from "../../session";
    import { navigate } from "svelte-routing";

    export let location;

    $: loadCity(selectedProvince);
    $: loadDistrict(selectedCity);

    let selectedProvince,
        selectedCity,
        selectedDistrict = "";

    let address = "";
    let provinces = [],
        cities = [],
        districts = [];

    function loadCity() {
        cities = [];
        selectedCity = "";
        districts = [];
        selectedDistrict = "";
        if (selectedProvince == "") return;
        post("/api/city", { province: selectedProvince }).then((resp) => {
            if (resp.status == 0) cities = resp.data;
        });
    }

    function loadDistrict() {
        districts = [];
        selectedDistrict = "";
        if (selectedCity == "") return;
        post("/api/district", {
            province: selectedProvince,
            city: selectedCity,
        }).then((resp) => {
            if (resp.status == 0) districts = resp.data;
        });
    }

    function next() {
        const shipper = getObject("shipper");
        shipper["province"] = selectedProvince;
        shipper["city"] = selectedCity;
        shipper["zipcode"] = "-";
        shipper["latitude"] = "-";
        shipper["longitude"] = "-";
        shipper["district"] = selectedDistrict;
        shipper["origin_code"] = districts.find(
            (i) => (i.name = selectedDistrict)
        ).code;
        shipper["address"] = address;
        console.log(shipper);
        setObject("shipper", shipper);
        navigate("/shipper/name");
    }
    onMount(() => {
        title.set("Alamat Pengiriman");
        post("/api/province").then((resp) => {
            if (resp.status == 0) provinces = resp.data;
        });
    });
</script>

<div class="content padding-top">
    <Select
        bind:value={selectedProvince}
        variant="outlined"
        label="Provinsi"
        enhanced>
        {#each provinces as p}
            <Option value={p.name} selected={selectedProvince === p.name}>
                {p.name}
            </Option>
        {/each}
    </Select>

    {#if cities.length > 0}
        <Select
            bind:value={selectedCity}
            variant="outlined"
            label="Kota/Kabupaten"
            enhanced>
            {#each cities as c}
                <Option value={c.name} selected={selectedCity === c.name}>
                    {c.name}
                </Option>
            {/each}
        </Select>
    {/if}
    {#if districts.length > 0}
        <Select
            bind:value={selectedDistrict}
            variant="outlined"
            label="Kecamatan/Kelurahan"
            enhanced>
            {#each districts as d}
                <Option value={d.name} selected={selectedDistrict === d}>
                    {d.name}
                </Option>
            {/each}
        </Select>
    {/if}
    {#if selectedDistrict != ''}
        {#if selectedDistrict.code != ''}
            <Textfield
                textarea
                bind:value={address}
                label="Alamat Lengkap"
                input$rows="4"
                input$placeholder="Masukkan nama jalan/gedung/apartemen, no rumah, RT/RW, dan alamat lainnya" />
        {/if}
        {#if address.length > 10}
            <Button on:click={next} variant="unelevated" class="rounded">
                Lanjutkan
            </Button>
        {/if}
    {/if}
</div>
